var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    _c(
      "div",
      { staticClass: "buttons" },
      [
        _c(
          "b-button",
          {
            staticClass: "is-warning",
            attrs: { "icon-left": "arrow-left" },
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          },
          [_vm._v(" Back ")]
        ),
        !_vm.creating
          ? _c(
              "b-button",
              {
                attrs: { "icon-left": "plus", type: "is-info" },
                on: {
                  click: () => {
                    _vm.creating = true
                  },
                },
              },
              [_vm._v(" Create ")]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm.creating
      ? _c("div", [
          _c("div", { staticClass: "section" }, [
            _c("h1", { staticClass: "title" }, [
              _vm._v(" Create report translation "),
            ]),
            _c("div", { staticClass: "flex-column" }, [
              _c("div", { staticClass: "flex-row space-between" }, [
                _c(
                  "div",
                  { staticClass: "flex-row" },
                  [
                    _c(
                      "b-field",
                      { staticClass: "field", attrs: { label: "Country" } },
                      [
                        _c("multiselect", {
                          attrs: {
                            options: _vm.countries,
                            multiple: false,
                            "close-on-select": true,
                            placeholder: "Pick country...",
                            label: "name",
                            "track-by": "name",
                          },
                          model: {
                            value: _vm.newReportTranslation.country,
                            callback: function ($$v) {
                              _vm.$set(_vm.newReportTranslation, "country", $$v)
                            },
                            expression: "newReportTranslation.country",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      {
                        staticClass: "field",
                        attrs: { label: "Sheet number" },
                      },
                      [
                        _c("b-input", {
                          attrs: {
                            name: "sheetNbr",
                            type: "number",
                            icon: "file",
                          },
                          model: {
                            value: _vm.newReportTranslation.sheetNbr,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.newReportTranslation,
                                "sheetNbr",
                                $$v
                              )
                            },
                            expression: "newReportTranslation.sheetNbr",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "is-warning",
                        on: {
                          click: () => {
                            _vm.creating = false
                          },
                        },
                      },
                      [_vm._v(" Cancel ")]
                    ),
                    _c(
                      "b-button",
                      { staticClass: "is-primary", on: { click: _vm.submit } },
                      [_vm._v(" Submit ")]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", [
                _c("table", { staticClass: "table is-fullwidth" }, [
                  _vm._m(0),
                  _c(
                    "tbody",
                    [
                      _vm._l(
                        _vm.newReportTranslation.translations,
                        function (translation, index) {
                          return _c("tr", { key: index }, [
                            _c("td", [
                              _c(
                                "div",
                                [
                                  _c("b-button", {
                                    staticClass: "is-danger",
                                    attrs: { "icon-left": "minus" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeRow(index)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              "td",
                              { staticStyle: { width: "100px" } },
                              [
                                _c("b-input", {
                                  attrs: { type: "number" },
                                  model: {
                                    value: translation.index,
                                    callback: function ($$v) {
                                      _vm.$set(translation, "index", $$v)
                                    },
                                    expression: "translation.index",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                _c("b-input", {
                                  attrs: { type: "text" },
                                  model: {
                                    value: translation.text,
                                    callback: function ($$v) {
                                      _vm.$set(translation, "text", $$v)
                                    },
                                    expression: "translation.text",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                _c("b-input", {
                                  attrs: { type: "text" },
                                  model: {
                                    value: translation.trad,
                                    callback: function ($$v) {
                                      _vm.$set(translation, "trad", $$v)
                                    },
                                    expression: "translation.trad",
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        }
                      ),
                      _c(
                        "div",
                        [
                          _c("b-button", {
                            staticClass: "is-info",
                            attrs: { "icon-left": "plus" },
                            on: { click: _vm.addRow },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticStyle: { padding: "5px" } },
      [
        _c("ag-grid-vue", {
          staticClass: "ag-theme-balham",
          staticStyle: { width: "100%", height: "1000px" },
          attrs: {
            "row-data": _vm.reportTranslations,
            "grid-options": _vm.gridOptions,
            pagination: true,
            "pagination-auto-page-size": true,
            "multi-sort-key": "ctrl",
            modules: _vm.modules,
            "row-selection": "multiple",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _c("th", [_vm._v("index")]),
        _c("th", [_vm._v("text")]),
        _c("th", [_vm._v("translation")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }